import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IChangeHistoryMessage } from '@modules/change-history/components/VChangeHistory/types';
import type { IContextQueryResult } from '@modules/core/services/query/types';
import { isServerValidationError } from '@modules/core/errors';
import { useRestClient } from '@modules/core/services/api';
import {
  useContextQuery,
} from '@modules/core/services/query';

import type {
  IDashboardPlayerCheckPayload,
  IDashboardPlayerCheckResponse,
} from '../types';
import {
  DASHBOARD_PERMISSIONS,
  DASHBOARD_PLAYER_CHECK_QUERY_KEY,
  DASHBOARD_PLAYER_CHECK_URL,
} from '../constants';

export default function useDashboardPlayerCheckQuery(
  payload: Ref<IDashboardPlayerCheckPayload>,
): IContextQueryResult<IDashboardPlayerCheckResponse, Error, IChangeHistoryMessage> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IDashboardPlayerCheckResponse, Error, IChangeHistoryMessage>({
    queryKey: [DASHBOARD_PLAYER_CHECK_QUERY_KEY, payload],
    queryFn: async () => {
      try {
        return await fetchGet(DASHBOARD_PLAYER_CHECK_URL, {
          queryParams: payload.value,
          permission: DASHBOARD_PERMISSIONS.DASHBOARD_PLAYERS_CHECK,
        });
      } catch (error) {
        if (isServerValidationError<undefined, IDashboardPlayerCheckResponse>(error)) {
          return error.response;
        }
        throw error;
      }
    },
    staleTime: 5000,
    select: (res) => res.result.message,
    enabled: computed(() => !!payload.value.cid),
  });
}
